// extracted by extract-css-chunks-webpack-plugin
module.exports = {"followable_user":"FollowableUser__followable_user--2gE56"};